import { AxiosError } from "axios";
import { PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import { Parceiro, ListarParceirosQuery } from "../typings";
import http from "infra/http";

export function useListarParceiro(query: ListarParceirosQuery) {
  return useQuery<PaginateResult<Parceiro>, AxiosError>(
    `/v1/parceiro-${query.search}-${query.page}-${query.limit}-${query.statusId}`,

    async () => {
      const { data } = await http.get<PaginateResult<Parceiro>>("/v1/parceiro", {
        params: query
      });

      return data;
    }
  );
}
